import { defineStore } from "pinia";
import { api } from "../api";

/** Pending addition/removal request counts, shown as nav badges so admins know there's
 * something to action without opening either page. */
export const useAdminCounts = defineStore("adminCounts", {
  state: () => ({
    additionPending: 0,
    removalPending: 0,
    assignedPending: 0,
  }),
  actions: {
    async load(): Promise<void> {
      try {
        const [additions, removals, assigned] = await Promise.all([
          api.additionRequests("pending"),
          api.deletionRequests("pending"),
          api.assignedWorkCount(),
        ]);
        this.additionPending = additions.length;
        this.removalPending = removals.length;
        this.assignedPending = assigned.count;
      } catch {
        // Badges are a convenience; a failed refresh shouldn't take the nav down.
      }
    },
  },
});
